// locales/en.ts
import { Translations } from '../types/language';

export const enTranslations: Translations = {
  // Header
  appTitle: "🌐 ClipShare",
  appSubtitle: "Multipoint clipboard sharing via WebRTC",
  
  // Main Menu
  oneTimeSharing: "One-time sharing",
  oneTimeSharingDesc: "Create or join a temporary session for clipboard sharing",
  userAccount: "User account",
  userAccountDesc: "Persistent sharing with history and advanced features",
  comingSoon: "Coming soon...",
  
  // Session Setup
  oneTimeSharingTitle: "🚀 One-time sharing",
  yourNickname: "👤 Your nickname:",
  enterNickname: "Enter your nickname...",
  nicknameDesc: "This nickname will be displayed to other participants",
  createSession: "📡 Create session",
  joinSession: "🔗 Join session",
  clickToCreateCode: "Click to create session code",
  createCode: "🎯 Create code",
  yourSessionCode: "Your session code",
  shareThisCode: "Share this code with other participants",
  copyCode: "📋 Copy code",
  startChat: "💬 Start chat",
  chatAutoOpen: "💡 Chat will automatically open when someone joins",
  enterSessionCode: "Enter session code:",
  connect: "🚀 Connect",
  paste: "📋 Paste",
  backToMenu: "← Back to main menu",
  
  // Chat Room
  session: "Session:",
  connected: "Connected",
  connecting: "Connecting...",
  disconnected: "Disconnected",
  unknownStatus: "Unknown status",
  participants: "participants",
  participant: "participant",
  you: "You",
  leave: "🚪 Leave",
  
  // Chat Messages
  messagesWillAppear: "💬 Clipboard messages will appear here",
  clickToCopy: "Click on message to copy to clipboard",
  typeMessage: "Type a message...",
  send: "📤 Send",
  
  // Clipboard Monitor
  autoTracking: "🔄 Auto tracking",
  manualChat: "💬 Manual chat",
  watchingClipboard: "👁️ Watching clipboard",
  monitoringPaused: "⏸️ Monitoring paused",
  pause: "⏸️ Pause",
  start: "▶️ Start",
  manualMode: "💬 Manual mode - enter messages below",
  
  // Context Menu
  copyAsPlainText: "📄 Copy as plain text",
  copyToClipboard: "📋 Copy to clipboard",
  downloadImage: "💾 Download image",
  
  // Alerts
  codeCreated: "Session code created!",
  connectedToSession: "Connected to session!",
  userJoined: "joined! Chat started.",
  chatStarted: "Chat started! Share the code with others and wait for connections...",
  allParticipantsLeft: "All participants left. Waiting for new connections...",
  waitingForNew: "Waiting for new connections...",
  sessionEnded: "Session ended",
  sessionTerminated: "Session was terminated",
  codeCopied: "Code copied to clipboard!",
  failedToCopyCode: "Failed to copy code",
  codeFromClipboard: "Code pasted from clipboard",
  invalidCodeInClipboard: "Invalid code in clipboard",
  failedToReadClipboard: "Failed to read from clipboard",
  chatStartedShare: "Chat started! Share code with others and wait for connections...",
  textCopied: "Text copied to clipboard!",
  imageCopied: "Image copied to clipboard!",
  failedToCopy: "Failed to copy content",
  textCopiedPlain: "Text copied as plain text!",
  imageDownloaded: "Image downloaded",
  
  // Errors
  serverNotConnected: "Server connection is not active",
  enterValidCode: "Enter a valid 6-digit code",
  
  // Message types
  image: "Image"
};